import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { Back2topComponent } from './back2top.component';

@NgModule({
  declarations: [ 
    Back2topComponent
    ],
  imports: [
    RouterModule,
    CommonModule
  ],
  exports: [
    Back2topComponent
  ]
})
export class Back2topLibModule {
 
}